import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useTheme } from '../../context/ThemeContext'
import '../../styles/editor-palette.css'

// ─── Inline SVG icons ─────────────────────────────────────────────────────────

const Icon = ({ name, size = 14 }) => {
  const icons = {
    dashboard: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="1" y="1" width="6" height="6" rx="1.5" />
        <rect x="9" y="1" width="6" height="6" rx="1.5" />
        <rect x="1" y="9" width="6" height="6" rx="1.5" />
        <rect x="9" y="9" width="6" height="6" rx="1.5" />
      </svg>
    ),
    clients: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="6" cy="5" r="3" />
        <path d="M1 14c0-3 2.2-5 5-5h.5" />
        <circle cx="12" cy="9" r="2.5" />
        <path d="M9 14c0-2 1.3-3 3-3s3 1 3 3" />
      </svg>
    ),
    sites: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="8" cy="8" r="6.5" />
        <path d="M1.5 8h13M8 1.5c-2 2-3 4-3 6.5s1 4.5 3 6.5M8 1.5c2 2 3 4 3 6.5s-1 4.5-3 6.5" />
      </svg>
    ),
    analytics: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <polyline points="1,12 5,7 8,10 11,5 15,8" />
        <line x1="1" y1="14.5" x2="15" y2="14.5" />
      </svg>
    ),
    requests: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M2 2h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5l-3 2V3a1 1 0 0 1 1-1z" />
      </svg>
    ),
    media: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="1" y="1" width="14" height="14" rx="2" />
        <circle cx="5.5" cy="5.5" r="1.5" />
        <polyline points="1,11 5,7 8,10 11,7 15,11" />
      </svg>
    ),
    domains: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z" />
        <path d="M1 8h14" />
        <path d="M8 1c-1.5 2-2.5 4-2.5 7s1 5 2.5 7c1.5-2 2.5-4 2.5-7S9.5 3 8 1z" />
      </svg>
    ),
    billing: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="1" y="3.5" width="14" height="10" rx="1.5" />
        <line x1="1" y1="7" x2="15" y2="7" />
        <line x1="4" y1="10.5" x2="7" y2="10.5" />
      </svg>
    ),
    settings: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="8" cy="8" r="2.5" />
        <path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.1 3.1l1.4 1.4M11.5 11.5l1.4 1.4M3.1 12.9l1.4-1.4M11.5 4.5l1.4-1.4" />
      </svg>
    ),
    editor: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M11 2l3 3-8 8H3v-3l8-8z" />
        <line x1="9" y1="4" x2="12" y2="7" />
      </svg>
    ),
    home: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M2 7L8 2l6 5" />
        <path d="M4 7v6h3v-4h2v4h3V7" />
      </svg>
    ),
    help: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="8" cy="8" r="6.5" />
        <path d="M6 6.2C6.2 5 7 4.5 8 4.5c1.1 0 2 .8 2 1.8 0 1.2-1 1.7-2 2v1" />
        <circle cx="8" cy="11.5" r=".5" fill="currentColor" />
      </svg>
    ),
    theme: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M8 1a7 7 0 0 0 0 14A5 5 0 0 0 8 1z" />
      </svg>
    ),
    logout: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M6 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3" />
        <polyline points="10,5 13,8 10,11" />
        <line x1="13" y1="8" x2="6" y2="8" />
      </svg>
    ),
    search: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="7" cy="7" r="5" />
        <line x1="11" y1="11" x2="14.5" y2="14.5" />
      </svg>
    ),
  }
  return icons[name] ?? icons.settings
}

// ─── CommandPalette ───────────────────────────────────────────────────────────

const CommandPalette = () => {
  const [open,  setOpen]  = useState(false)
  const [query, setQuery] = useState('')
  const [idx,   setIdx]   = useState(0)
  const inputRef = useRef(null)
  const navigate = useNavigate()
  const { user, logout, isAdmin } = useAuth()
  const { toggleTheme } = useTheme()

  // ── Open / close via keyboard ─────────────────────────────────────────────
  useEffect(() => {
    const onKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setOpen(v => !v)
        setQuery('')
        setIdx(0)
      }
      if (e.key === 'Escape') {
        setOpen(false)
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [])

  // Focus input when opened
  useEffect(() => {
    if (open) {
      setTimeout(() => inputRef.current?.focus(), 0)
    }
  }, [open])

  // ── Build command list based on role ──────────────────────────────────────
  const buildCommands = useCallback(() => {
    const adminCommands = [
      { group: 'Navigation', icon: 'dashboard', label: 'Dashboard',     shortcut: 'G D', action: () => navigate('/admin/dashboard') },
      { group: 'Navigation', icon: 'clients',   label: 'Clients',       shortcut: 'G C', action: () => navigate('/admin/clients') },
      { group: 'Navigation', icon: 'sites',     label: 'Sites',         shortcut: 'G S', action: () => navigate('/admin/sites') },
      { group: 'Navigation', icon: 'analytics', label: 'Analytics',              action: () => navigate('/admin/analytics') },
      { group: 'Navigation', icon: 'requests',  label: 'Requests',               action: () => navigate('/admin/requests') },
      { group: 'Navigation', icon: 'media',     label: 'Media',                  action: () => navigate('/admin/media') },
      { group: 'Navigation', icon: 'domains',   label: 'Domains',                action: () => navigate('/admin/domains') },
      { group: 'Navigation', icon: 'billing',   label: 'Billing',                action: () => navigate('/admin/billing') },
      { group: 'Navigation', icon: 'settings',  label: 'Settings',               action: () => navigate('/admin/settings') },
      { group: 'Navigation', icon: 'editor',    label: 'Visual Editor',  shortcut: 'G E', action: () => navigate('/admin/neweditor') },
    ]

    const clientCommands = [
      { group: 'Navigation', icon: 'home',      label: 'Home',                   action: () => navigate('/client/dashboard') },
      { group: 'Navigation', icon: 'editor',    label: 'Edit My Site',           action: () => navigate('/client/editor') },
      { group: 'Navigation', icon: 'requests',  label: 'Requests',               action: () => navigate('/client/requests') },
      { group: 'Navigation', icon: 'analytics', label: 'Analytics',              action: () => navigate('/client/analytics') },
      { group: 'Navigation', icon: 'domains',   label: 'Domain',                 action: () => navigate('/client/domain') },
      { group: 'Navigation', icon: 'billing',   label: 'Billing',                action: () => navigate('/client/billing') },
      { group: 'Navigation', icon: 'help',      label: 'Help',                   action: () => navigate('/client/help') },
    ]

    const globalCommands = [
      { group: 'Actions', icon: 'theme',  label: 'Toggle Dark Mode', action: () => { toggleTheme(); setOpen(false) } },
      { group: 'Actions', icon: 'logout', label: 'Sign Out',         action: () => { logout(); setOpen(false) } },
    ]

    return [
      ...(isAdmin ? adminCommands : clientCommands),
      ...globalCommands,
    ]
  }, [isAdmin, navigate, toggleTheme, logout])

  const allCommands = buildCommands()

  // ── Filter by query ───────────────────────────────────────────────────────
  const filtered = query.trim()
    ? allCommands.filter(c => c.label.toLowerCase().includes(query.toLowerCase()))
    : allCommands

  // ── Group filtered results ────────────────────────────────────────────────
  const groups = filtered.reduce((acc, item) => {
    ;(acc[item.group] = acc[item.group] || []).push(item)
    return acc
  }, {})

  // ── Arrow key navigation ──────────────────────────────────────────────────
  const onKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      setIdx(i => Math.min(i + 1, filtered.length - 1))
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      setIdx(i => Math.max(i - 1, 0))
    } else if (e.key === 'Enter') {
      const item = filtered[idx]
      if (item) {
        item.action()
        setOpen(false)
      }
    }
  }

  // ── Render ────────────────────────────────────────────────────────────────
  if (!open) return null

  let flatIdx = 0

  return (
    <div
      className="cmd-backdrop"
      onClick={() => setOpen(false)}
      role="dialog"
      aria-modal="true"
      aria-label="Command palette"
    >
      <div
        className="cmd-box"
        onClick={e => e.stopPropagation()}
      >
        {/* Search input */}
        <div className="cmd-input-wrap">
          <Icon name="search" size={16} />
          <input
            ref={inputRef}
            className="cmd-input"
            placeholder="Type a command, search pages or actions…"
            value={query}
            onChange={e => { setQuery(e.target.value); setIdx(0) }}
            onKeyDown={onKeyDown}
            autoComplete="off"
            spellCheck={false}
          />
          <span
            style={{
              fontSize: 11,
              color: 'var(--text-faint)',
              background: 'var(--bg-0)',
              border: '1px solid var(--border)',
              borderRadius: 4,
              padding: '2px 6px',
              flexShrink: 0,
            }}
          >
            esc
          </span>
        </div>

        {/* Results */}
        <div className="cmd-results">
          {filtered.length === 0 ? (
            <div className="cmd-empty">
              No results for "{query}"
            </div>
          ) : (
            Object.entries(groups).map(([group, items]) => (
              <div key={group}>
                <div className="cmd-group-label">{group}</div>
                {items.map(item => {
                  const itemIdx = flatIdx++
                  const isFocused = idx === itemIdx
                  return (
                    <button
                      key={item.label}
                      className={`cmd-item${isFocused ? ' focused' : ''}`}
                      onMouseEnter={() => setIdx(itemIdx)}
                      onClick={() => { item.action(); setOpen(false) }}
                    >
                      <span className="cmd-item-icon">
                        <Icon name={item.icon} size={14} />
                      </span>
                      <span className="cmd-item-label">{item.label}</span>
                      {item.shortcut && (
                        <span className="cmd-item-shortcut">{item.shortcut}</span>
                      )}
                    </button>
                  )
                })}
              </div>
            ))
          )}
        </div>

        {/* Footer hint */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            padding: '8px 16px',
            borderTop: '1px solid var(--border)',
            fontSize: 11,
            color: 'var(--text-faint)',
          }}
        >
          <span>
            <kbd style={{ fontSize: 10, padding: '1px 5px', border: '1px solid var(--border)', borderRadius: 3, background: 'var(--bg-0)' }}>↑</kbd>
            {' '}
            <kbd style={{ fontSize: 10, padding: '1px 5px', border: '1px solid var(--border)', borderRadius: 3, background: 'var(--bg-0)' }}>↓</kbd>
            {' navigate'}
          </span>
          <span>
            <kbd style={{ fontSize: 10, padding: '1px 5px', border: '1px solid var(--border)', borderRadius: 3, background: 'var(--bg-0)' }}>↵</kbd>
            {' open'}
          </span>
          <span>
            <kbd style={{ fontSize: 10, padding: '1px 5px', border: '1px solid var(--border)', borderRadius: 3, background: 'var(--bg-0)' }}>⌘K</kbd>
            {' toggle'}
          </span>
          {user?.name && (
            <span style={{ marginLeft: 'auto' }}>
              {user.name}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default CommandPalette
